import { initSubRoutes } from '../../../utils/router';

const RoutesPriveeNousContacter = initSubRoutes({
    route: '/espace-detenteurs/nous-contacter',
    subroutes: {},
    nom: 'Nous contacter',
});

export default RoutesPriveeNousContacter;
